import { BomAndSummaryBtn } from "../BomAndSummary/BomAndSummaryBtn";

import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { AppBar, Backdrop, Box, Button, CircularProgress } from "@mui/material";
import Container from "@mui/material/Container";
import {
  useCsAttributeById,
  useLoadConfigurationFromFile,
  useSaveConfigurationToFile,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

import { openResponsePdfInNewTab } from "./helper";

export function Footer(): JSX.Element {
  const [isPrinting, setIsPrinting] = useState(false);
  const { t } = useTranslation();
  const sessionId = useSessionId();
  const fileLoadInput = useLoadConfigurationFromFile();
  const fileSave = useSaveConfigurationToFile();

  const language =
    new URLSearchParams(window.location.search).get("lang") || "de-DE";

  const attributeModell = useCsAttributeById("A_MODELL");
  const advancedButtonsEnabled = attributeModell?.isComplete === true;

  async function handlePrint(): Promise<void> {
    setIsPrinting(true);
    try {
      const pdfUrl = `custom/api/configuration/document/${sessionId}/pdf?localeId=${language}`;

      const resp = await fetch(pdfUrl, {
        headers: {
          Accept: "application/pdf",
        },
      });

      await openResponsePdfInNewTab(resp);
    } catch (_err) {
      console.error("Error generating or opening PDF", _err);
    } finally {
      setIsPrinting(false);
    }
  }

  return (
    <>
      <AppBar
        component="footer"
        color="inherit"
        sx={{
          bottom: 0,
          top: "auto",
          zIndex: 1049,
        }}
      >
        <Container maxWidth="xl" sx={{ paddingLeft: "24px" }}>
          <Box display="flex" gap="1rem" alignItems="center">
            <BomAndSummaryBtn disabled={!advancedButtonsEnabled} />
            <Box
              gap="1rem"
              display="flex"
              padding="0.5rem 0"
              height="4rem"
              alignItems="center"
            >
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                variant="contained"
                onClick={fileSave.handleSaveFile}
              >
                {t("AS:footer.button.save")}
              </Button>
              <Button
                startIcon={<FileUploadOutlinedIcon />}
                variant="contained"
                onClick={fileLoadInput.openFile}
              >
                {t("AS:footer.button.load")}
              </Button>
              {fileLoadInput.inputElement}
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                variant="contained"
                onClick={handlePrint}
                disabled={isPrinting || !advancedButtonsEnabled}
              >
                {t("AS:footer.button.printPdf")}
              </Button>

              {/*<Button*/}
              {/*  variant="contained"*/}
              {/*  startIcon={<MailOutlineOutlinedIcon />}*/}
              {/*  onClick={() => console.log("Vertrieb Kontaktieren event")}*/}
              {/*  disabled*/}
              {/*>*/}
              {/*  {t("AS:footer.button.contactSales")}*/}
              {/*</Button>*/}

              {/*<Button*/}
              {/*  variant="contained"*/}
              {/*  startIcon={<StarBorderOutlinedIcon />}*/}
              {/*  onClick={() => console.log("Zur Merkliste Hinzufuegen event")}*/}
              {/*  disabled*/}
              {/*>*/}
              {/*  {t("AS:footer.button.addToWatchlist")}*/}
              {/*</Button>*/}
            </Box>
          </Box>
        </Container>
      </AppBar>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={isPrinting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
